import { z } from 'zod';
import LangEnum from '../../lang/LangEnum';
import { yupValidateCNPJ } from '../../utils/validators';

export const cnpjSchema = z
  .string()
  .min(1, LangEnum.GLOBAL_REQUIRED)
  .refine(yupValidateCNPJ, LangEnum.GLOBAL_INVALID_CNPJ);
